// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/scss/birmingham-meme.scss
// module id = 222
// module chunks = 0